import React from 'react'
import { Form } from 'semantic-ui-react'

export default function TextInput(props) {
  const handleChange = (_, { value }) => {
    if (props.onChange) {
      props.onChange(value)
    }
  }

  return (
    <Form.Input
      {...props}
      placeholder={props.placeholder || props.label}
      value={props.value || ''}
      onChange={handleChange}
    />
  )
}

TextInput.defaultProps = {
  type: 'text',
  label: null,
  placeholder: null,
  disabled: false,
  loading: false,
  transparent: false,
  error: false,
  value: null,
  children: null,
  onChange: () => {},
}
